/**
 * L'état d'interface de « Paramètres » de l'élève : ses quatre pages sur l'état commun
 * (`ui/hooks/settingsUiState`, le même que le tuteur).
 */
import {
    type ApiNotificationSettings,
    type StudentSettingsSection,
} from "../../../../adapters/student/Account/studentSettingsAdapter"
import {
    initialSettingsUiState,
    settingsUiReducer,
    type SettingsUiAction,
    type SettingsUiState,
} from "../../../hooks/settingsUiState"
import {
    type UIStudentAddressSettings,
    type UIStudentGeneralSettings,
    type UIStudentProfileSettings,
} from "../../../types/studentAccount"

export { isSectionDirty } from "../../../hooks/settingsUiState"

export type StudentSettingsDrafts = {
    general: UIStudentGeneralSettings | null
    address: UIStudentAddressSettings | null
    profile: UIStudentProfileSettings | null
    preferences: ApiNotificationSettings | null
}

export type StudentSettingsUiState = SettingsUiState<StudentSettingsSection, StudentSettingsDrafts>
export type StudentSettingsUiAction = SettingsUiAction<StudentSettingsSection>

const EMPTY_DRAFTS: StudentSettingsDrafts = { general: null, address: null, profile: null, preferences: null }

/** `settings` reçoit l'index d'un onglet d'aujourd'hui : 0 (Général, l'onglet par défaut) ouvre la liste. */
const VIEW_BY_TAB: Record<number, StudentSettingsSection> = { 1: "address", 2: "profile", 3: "preferences" }

export function initialStudentSettingsUiState(initialTab?: unknown): StudentSettingsUiState {
    return initialSettingsUiState(VIEW_BY_TAB, EMPTY_DRAFTS, initialTab)
}

export function studentSettingsUiReducer(
    state: StudentSettingsUiState,
    action: StudentSettingsUiAction
): StudentSettingsUiState {
    return settingsUiReducer(state, action)
}
